import * as React from 'react'

import type AccessGroup from 'modules/core/store/models/AccessGroup'

import type { Participant } from 'modules/surveys/lib/participant'

import Table from './Table'

interface Props {
  accessGroup?: AccessGroup | null | undefined
  surveyId: string
  participants: Participant[]
}

export default function AccessGroupTable({ accessGroup, surveyId, participants }: Props) {
  if (!accessGroup) return null

  return <Table accessGroup={accessGroup} surveyId={surveyId} participants={participants} />
}
